const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8000";

export function authFetch(url, options = {}) {
  const token = localStorage.getItem("token");
  return fetch(`${API_BASE}${url}`, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "application/json",
    },
  }).then(async (res) => {
    if (res.status === 401) {
      // token invalid/expired → redirect to login
      window.location.href = "/login";
      return Promise.reject("Unauthorized");
    }
    return res.json();
  });
}

export async function fetchListingsWithPredictions(filters = {}) {
  const params = new URLSearchParams();

  if (filters.search) params.append('search', filters.search);
  if (filters.date_from) params.append('date_from', filters.date_from);
  if (filters.date_to) params.append('date_to', filters.date_to);
  if (filters.beds_min) params.append('beds_min', filters.beds_min);
  if (filters.beds_max) params.append('beds_max', filters.beds_max);
  if (filters.baths_min) params.append('baths_min', filters.baths_min);
  if (filters.baths_max) params.append('baths_max', filters.baths_max);
  if (filters.price_min) params.append('price_min', filters.price_min);
  if (filters.price_max) params.append('price_max', filters.price_max);
  if (filters.cap_rate_min) params.append('cap_rate_min', filters.cap_rate_min);
  if (filters.cap_rate_max) params.append('cap_rate_max', filters.cap_rate_max);
  if (filters.days_on_market_max) params.append('days_on_market_max', filters.days_on_market_max);
  if (filters.property_type) params.append('property_type', filters.property_type);
  if (filters.neighborhood_ids) params.append('neighborhood_ids', filters.neighborhood_ids);

  const queryString = params.toString();
  const url = `/listings/sale-with-predictions${queryString ? `?${queryString}` : ''}`;
  const data = await authFetch(url);
  return data;
}

export const fetchPrediction = async (propertyId) => {
  const data = await authFetch(`/predict/sale/${propertyId}`);
  console.log("fetchPrediction",data);
  return data;
};
